import { RESTORE_PREVIOUS_STATE } from 'constants/actionTypes';

export function restorePreviousState() {
  return {
    type: RESTORE_PREVIOUS_STATE,
  };
}
